import { Injectable } from '@angular/core';

export interface LocalStorageEntry {
  key: string;
  value: string;
}

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  setItem(items: LocalStorageEntry[]): void {
    items.forEach(({ key, value }) => localStorage.setItem(key, value));
  }

  removeItem(keys: string[]): void {
    keys.forEach((key) => localStorage.removeItem(key));
  }

  clear(): void {
    localStorage.clear();
  }
}
